<template>
  <a-layout>
    <a-space>
      <vxe-input v-model="query.no" clearable placeholder="business.label.no" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="query.name" clearable placeholder="business.label.name" size="small" type="search" @search-click="refresh"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.no" width="150"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.name" width="400"/>
      <vxe-column :cell-render="{name:'VxeInput',autoSelect:true,props:{disabled:true}}" field="mnemonicCode" title="business.label.mnemonicCode" width="200"/>
      <vxe-column :edit-render="{name:'VxeSelect',options:dataSources}" field="dataSource" title="business.label.dataSource" width="120"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="hotline" title="business.label.hotline" width="150"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="chargeup" title="business.label.chargeup" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE, SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll, findEnum, saveAll } from '@/api/Api'
import { Storer } from '@/api/dto/common/Storer'

export default {
  name: 'StorerTable',
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new Storer(),
      page: 1,
      size: 20,
      contentSize: 0,
      dataSources: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.775),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ]
      }
    }
  },
  created() {
    findEnum('DataSource').then(res => {
      if (res.success) {
        this.dataSources = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    dblclick(row) {
      if (!this.$refs.table.isEditByRow(row)) {
        this.$emit('dblClick', row)
      }
    },
    fetch() {
      this.loading = true
      findAll('storerFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new Storer(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.data.push(new Storer())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('storerPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>